module.exports = __webpack_public_path__ + "static/media/FENGYUN 3C.b97f0852.czml";